var React = require('react');

function HeaderLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"open-in-new","d":"M11.2,11.588V6.7h1.412v4.893A1.4,1.4,0,0,1,11.2,13H1.412a1.362,1.362,0,0,1-1-.41,1.364,1.364,0,0,1-.41-1V1.8A1.362,1.362,0,0,1,.41.8a1.364,1.364,0,0,1,1-.41H6.3V1.8H1.412v9.785ZM9.107-1H14V3.893H12.588V1.4L7.716,6.7,6.731,5.71,11.6.412h-2.5Z","transform":"translate(0 1)","opacity":"0.6"}));
}

HeaderLink.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 14 14","stroke":"currentcolor","fill":"currentcolor","strokeWidth":"0"};

module.exports = HeaderLink;

HeaderLink.default = HeaderLink;
